import Icon from '@wetransfer/transfer/component/icon';
import LinkHelper from '@wetransfer/transfer/component/navigation/helpers/link';
import Links from '@wetransfer/transfer/component/navigation/links';
import { userHasPaidTier } from '@wetransfer/transfer/helper/user';

const accountUser = (navigation, user) => {
  if (userHasPaidTier(user)) {
    navigation = LinkHelper.removePricingPageLink(navigation, 'hamburger');
  }

  navigation = LinkHelper.replaceProfileName(navigation, '');

  return navigation;
};

export default {
  create: (user) => {
    Links.pricingItem.name = 'navigation.about_us.items.plans_and_pricing';

    let navigation = {
      hamburger: {
        id: 'hamburger',
        component: Icon,
        options: { type: 'Hamburger' },
        items: [
          Links.homeItem,
          Links.uploadItem,
          Links.pricingItem,
          Links.aboutItem,
          Links.helpItem,
        ],
      },
      logo: {
        id: 'logo',
        component: Icon,
        options: { type: 'Logo', shadow: false, width: 44 },
        path: '/',
      },
      account: Links.signupItem,
    };

    if (!user.loggedIn) {
      navigation.hamburger.items.splice(3, 0, Links.featuresItem(user));
      navigation.hamburger.items.push(Links.loginItem);
    }

    navigation = user.loggedIn ? accountUser(navigation, user) : navigation;

    return Object.values(navigation);
  },
};
